import { getField, updateField } from "vuex-map-fields";
import firebase from "firebase";
const state = {
    imagePath: "",
    isUpdate: false,
    uploadingImage: false,
    deletingImage: false,
    selectedDate: "",
    selectedTime: "",
    formPopulator: null,
    selectedDateTime: 1609448520 // initial timestamp set to 01/01/2021
};
// Storage RULE is here 
// allow read, write: if request.auth != null;
const actions = {
    async uploadImage({ commit }, { payload }) {

        commit("updateField", {
            path: "uploadingImage",
            value: true,
        })
        // Anonymously Sign in to by pass Unauth access Error
        var anonymousSignIn = await firebase.auth().signInAnonymously();

        if (anonymousSignIn) {
            await firebase.storage().ref('/uploads' + '/news/' + payload.imageName).put(payload.image, payload.metadata)
                .then(async () => {
                    await firebase.storage().ref('/uploads' + '/news/' + payload.imageName).getDownloadURL()
                        .then((imageUrl) => {

                            commit("updateField", {
                                path: "imagePath",
                                value: imageUrl,
                            })
                            commit("updateField", {
                                path: "uploadingImage",
                                value: false,
                            })
                        })
                })
        }

    },
    setImagePath({ commit }, { payload }) {
        commit("updateField", {
            path: "imagePath",
            value: payload.path,
        })
    },
    clearImagePath({ commit }) {
        commit("updateField", {
            path: "imagePath",
            value: "",
        })
    },
    async removeImage({ commit }, { payload }) {
        commit("updateField", {
            path: "deletingImage",
            value: true,
        })
        await firebase.storage().ref('/uploads' + '/news/' + payload.imageName).delete()
            .then(() => {
                commit("updateField", {
                    path: "imagePath",
                    value: "",
                })
                commit("updateField", {
                    path: "deletingImage",
                    value: false,
                })
            })
    },

    dateSelected({ commit }, { payload }) {
        var date = payload.date

        commit("updateField", {
            path: "selectedDate",
            value: date,
        })
    },

    timeSelected({ commit }, { payload }) {
        var time = payload.time

        commit("updateField", {
            path: "selectedTime",
            value: time,
        })
    },

    dateTimeSelected({ commit }, { payload }) {

        var dateTime = payload.datetime

        var timeStamp = Math.round(new Date(dateTime).getTime() / 1000)

        commit("updateField", {
            path: "selectedDateTime",
            value: timeStamp,
        })
    },
    showEditForm({ commit }, { payload }) {

        commit("updateField", {
            path: "isUpdate",
            value: payload.isEdit,
        })
    },
    populateForm({ commit }, { payload }) {

        var formData = {
            id: payload.formdata.id,
            body: payload.formdata.body,
            date: payload.formdata.date,
            image: payload.formdata.image,
            likes: payload.formdata.likes,
            source: payload.formdata.source,
            title: payload.formdata.title,
            views: payload.formdata.views,
            type: payload.formdata.type
        }

        commit("updateField", {
            path: "formPopulator",
            value: formData,
        })
    },
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
